export const projectIdMap = new Map([['kubernetes', 'a092M00001IV42DQAT']]);
